import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Iconify from "../../theme/iconify/iconify";
import React from "react";
import Tooltip from "@mui/material/Tooltip";

function StatisticCard({ icon, label, value, width, tooltip, mdSize=3 }) {
    return (
        <Grid item xs={12} md={mdSize} sx={{ mb: { xs: 0, md: 1 } }}>
            <Paper elevation={2}>
                <Box
                    sx={{
                        p: 2,
                        backgroundColor: 'white',
                        borderRadius: '16px'
                    }}
                >
                    <Grid container>
                        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Grid item xs={6}>
                                {tooltip ?
                                    <Tooltip title={tooltip} arrow placement='top'>
                                        <Typography variant='h6' sx={{fontSize: '0.875rem !important', color: 'primary.main'}}>
                                            {label}
                                        </Typography>
                                    </Tooltip>
                                :
                                    <Typography variant='h6' sx={{fontSize: '0.875rem !important', color: 'primary.main'}}>
                                        {label}
                                    </Typography>
                                }
                                <Typography variant='h3'>
                                    {value}
                                </Typography>
                            </Grid>
                            <Iconify icon={icon} width={width} />
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
        </Grid>
    );
}

export default StatisticCard;